// src/pages/admin/editorTabs/LimitsTab.jsx
import React from "react";
import { normalizeLimits, DEFAULT_LIMITS } from "../utils/limitsUtils";

export default function LimitsTab({ limits, setLimits }) {
  const l = normalizeLimits(limits);

  const setField = (key, value) => {
    setLimits((prev) => ({ ...(prev || {}), [key]: value }));
  };

  const reset = () => setLimits({ ...DEFAULT_LIMITS });

  return (
    <div className="bg-white rounded-2xl shadow-sm border p-5 space-y-4">
      <div className="flex items-center justify-between">
        <div className="font-bold text-gray-900">Limits</div>
        <button onClick={reset} className="px-3 py-2 rounded-lg border hover:bg-gray-50">
          Reset
        </button>
      </div>

      <div className="text-sm text-gray-600">
        Leave a field empty to make it unlimited.
      </div>

      <div className="space-y-3">
        <div>
          <div className="text-sm font-medium text-gray-700 mb-1">Max sections per page</div>
          <input
            type="number"
            min="0"
            value={limits?.maxSections ?? ""}
            onChange={(e) => setField("maxSections", e.target.value)}
            className="w-full px-3 py-2 border rounded-lg"
            placeholder="unlimited"
          />
          <div className="text-xs text-gray-500 mt-1">Current: {l.maxSections === null ? "unlimited" : l.maxSections}</div>
        </div>

        <div>
          <div className="text-sm font-medium text-gray-700 mb-1">Max images per section</div>
          <input
            type="number"
            min="0"
            value={limits?.maxImagesPerSection ?? ""}
            onChange={(e) => setField("maxImagesPerSection", e.target.value)}
            className="w-full px-3 py-2 border rounded-lg"
            placeholder="unlimited"
          />
          <div className="text-xs text-gray-500 mt-1">Current: {l.maxImagesPerSection === null ? "unlimited" : l.maxImagesPerSection}</div>
        </div>

        <div>
          <div className="text-sm font-medium text-gray-700 mb-1">Max nav links</div>
          <input
            type="number"
            min="0"
            value={limits?.maxNavLinks ?? ""}
            onChange={(e) => setField("maxNavLinks", e.target.value)}
            className="w-full px-3 py-2 border rounded-lg"
            placeholder="unlimited"
          />
          <div className="text-xs text-gray-500 mt-1">Current: {l.maxNavLinks === null ? "unlimited" : l.maxNavLinks}</div>
        </div>

        <div>
          <div className="text-sm font-medium text-gray-700 mb-1">Max footer links</div>
          <input
            type="number"
            min="0"
            value={limits?.maxFooterLinks ?? ""}
            onChange={(e) => setField("maxFooterLinks", e.target.value)}
            className="w-full px-3 py-2 border rounded-lg"
            placeholder="unlimited"
          />
          <div className="text-xs text-gray-500 mt-1">Current: {l.maxFooterLinks === null ? "unlimited" : l.maxFooterLinks}</div>
        </div>
      </div>
    </div>
  );
}